import { FormSchema } from "../../../../interfaces/components/form";
import { FormComponent } from "../../../utils/enums";

export const loginSchema: FormSchema = {
  type: "object",
  properties: {
    email: {
      type: "string",
      label: "Email",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        type: "email",
        placeholder: "Enter your email",
        className:
          "w-full bg-gray-50 dark:bg-darkCardBackground border border-gray-300 dark:border-gray-700 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-cyan-400 dark:text-white",
      },
      validator: [
        {
          regex: "^[^\\s@]+@[^\\s@]+\\.[^\\s@]+$",
          message: "Please enter a valid email address",
        },
      ],
    },
    password: {
      type: "string",
      label: "Password",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        type: "password",
        placeholder: "Enter your password",
        className:
          "w-full bg-gray-50 dark:bg-darkCardBackground border border-gray-300 dark:border-gray-700 rounded-md px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 dark:focus:ring-cyan-400 dark:text-white",
      },
      validator: [],
    },
  },
};
